

class ShopByColourSwatch extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', () => {
			const tab = this.closest('tab-panel').getAttribute('tab');
			const swatches = this.closest('.sbc__swatches').querySelectorAll('sbc-swatch');
			swatches.forEach(s => s.removeAttribute('active'));

			this.setAttribute('active', '');
			this.replaceLink();

			const cardSwatches = this.closest('.shopify-section').querySelectorAll(`tab-panel[tab="${tab}"] card-swatch[colour="${this.getAttribute('colour')}"]`);
			for (const cardSwatch of cardSwatches) {
				cardSwatch.select();
			}
		});

		if (this.hasAttribute('active')) {
			const tab = this.closest('tab-panel').getAttribute('tab');
			
			const observer = new IntersectionObserver(async entries => {
				if (entries.some(e => e.isIntersecting)) {
					observer.disconnect();
					const swatchSelectors = this.closest('.shopify-section').querySelectorAll(`tab-panel[tab="${tab}"] card-swatch-selector`);
					for (const swatchSelector of swatchSelectors) {
						swatchSelector.load();
					}
				}
			});

			observer.observe(this);
		}

		const observer = new IntersectionObserver(entries => {
			if (entries.some(e => e.isIntersecting)) {
				if (this.hasAttribute('active')) this.replaceLink();
			}
		});

		observer.observe(this);
	}

	replaceLink() {
		const link = this.getAttribute('link');
		const button = this.closest('.shopify-section').querySelector('.sbc__button');
		if (button == null) return;

		const label = button.dataset.label.replace('[colour]', this.getAttribute('colour')); 
		const url = link && link.length > 0 ? link : button.dataset.link;

		button.href = url;
		button.textContent = label;
	}
}

customElements.define('sbc-swatch', ShopByColourSwatch);